import axios from "axios";

export const client = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
	headers: {
		"Content-Type": "application/json",
	},
});

const LOCAL_STORAGE_CLIENT_TOKEN = "client__token";

const setToken = (token: string) => {
	localStorage.setItem(LOCAL_STORAGE_CLIENT_TOKEN, token);
};

export const attachTokenToClient = (token?: string) => {
	if (token) {
		setToken(token);
	}
	client.interceptors.request.use(
		async (config) => {
			const authorizationToken = localStorage.getItem(
				LOCAL_STORAGE_CLIENT_TOKEN,
			);
			if (authorizationToken) {
				config.headers.Authorization = `Bearer ${authorizationToken}`;
			}
			return config;
		},
		(error) => {
			return Promise.reject(error);
		},
	);
};

export const getToken = () => {
	attachTokenToClient();
};
getToken();

export const unsetToken = () => {
	localStorage.removeItem(LOCAL_STORAGE_CLIENT_TOKEN);
};
